import * as React from 'react';
import { BCAddonButton, BCInputSearch, findMessage } from '../..';
import Styles from '../assets/style.scss';
import { ISearchBoxProps } from '../entities';

const PropertySearchBox = React.memo((props: ISearchBoxProps) => (
	<div className={Styles.propertySearchBox}>
		<BCAddonButton>
			<BCInputSearch
				placeHolder={findMessage.get('100002')}
				onSearch={props.onSearch}
				onChange={props.onChange}
				size="middle"
			/>
		</BCAddonButton>
	</div>
));

export default PropertySearchBox;
